/**
 * Custom Filters - Fan Collection
 * Template-specific configuration for the fan-collection template (passes the `collection` param)
 *
 * Requires: custom-filters-core.js to be loaded first
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get collection handle (slug) from URL
  let collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0] || 'all';

  // Name mapping for handles that don't match the API's collection value.
  // Shopify handleizes the collection title; map the URL handle to the real collection name here.
  // Plain handles that already match the API value need no entry — they fall through.
  const COLLECTION_NAME_MAPPING = {
    // 'shop-by-fan': 'fan',
  };

  // Map the URL handle to the actual collection name for API calls
  const apiParamValue = COLLECTION_NAME_MAPPING[collectionHandle.toLowerCase()] || collectionHandle;

  // Initialize with collection-specific config.
  // The collection slug is passed to the filter API via the `collection` param.
  window.CustomFilters.init({
    type: 'category',
    collectionHandle: collectionHandle,
    apiParamName: 'collections',
    apiParamValue: apiParamValue,
    excludedFilters: ['categories', 'subcategories', 'collections', 'locations', 'trends', 'motorTypes'],
    extraApiParams: {}
  });
});
